// eslint-disable-next-line no-shadow
enum StorageTypes {
  CustomerOrders = 'CustomerOrders',
}
export default StorageTypes;
